export class SetCloudPassword {
    email: string;
    password: string;
}